<template>
  <v-theme-provider>
    <div>
      <template v-for="({ icon, text, title: t }, i) in info">
        <base-avatar-card
          :key="i"
          :icon="icon"
          :outlined="false"
          :title="!dense ? t : undefined"
          color="transparent"
          horizontal
          space="0"
        >
          <!-- Do not use v-html for user -->
          <!-- provided values -->
          <div
            v-html="text"
          />
        </base-avatar-card>
      </template>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseBusinessContactNanotech',

    props: {
      dark: Boolean,
      dense: Boolean,
      title: String,
      countury: String,
    },

    data: () => ({
      info: [
        {
          icon: 'mdi-map-marker-radius',
          title: '본사',
          text: 'No. 9009 Qinglongshan Road,<br>255000, High tech Zone, Zibo City,<br>Shandong Province, China',
        },
        {
          icon: 'mdi-map-marker-outline',
          title: '동남아시아 거점 오피스',
          text: 'LC1, B40202, Jalan Pantai Sinaran,<br>11700, Gelugor,<br>Pulau Pinang, Malaysia',
        },
        {
          icon: 'mdi-email',
          title: '이메일',
          text: 'thomaswang@ronghaorobot.com',
        },
      ],
    }),
  }
</script>
